module.exports = __webpack_public_path__ + "static/map-e6f98da30bca5b95c6bcf7268d17a644.png";